import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { JoinPlatformButton } from './JoinPlatformButton';
import { Sparkles } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-185" data-mp="9k0b6xwjpxkw">
      {/* Full-width background image */}
      <div className="absolute inset-0" data-id="element-186" data-mp="4njng4t9dl8c">
        <img src="https://cdn.magicpatterns.com/uploads/dZ8Roj232HgCNMNue9AsoW/pexels-anntarazevich-4926666.jpg" alt="Women supporting each other" className="w-full h-full object-cover object-[center_30%] scale-110" data-id="element-187" data-mp="12a0n3gpgsax9" />
        {/* Subtle overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/40 via-charcoal/30 to-charcoal/50" data-id="element-188" data-mp="nczs94bz7zuk"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/20 to-transparent" data-id="element-189" data-mp="3d2l95b1th306"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10 text-center text-white" data-id="element-190" data-mp="381nwfdzkt162">
        <FadeIn delay={100} data-id="element-191" data-mp="3j9k9t8cxxbej">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full border border-white/30 bg-white/10 backdrop-blur-md mb-8" data-id="element-192" data-mp="3j9ah3d0igq55">
            <Sparkles className="w-4 h-4 text-purple-300" data-id="element-193" data-mp="39al7s8moke0i" />
            <span className="text-sm font-medium tracking-wide uppercase text-white/90" data-id="element-194" data-mp="39cflb1vmh3uk">
              A New Standard in Women's Wellness
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={300} data-id="element-195" data-mp="30gq4z7916zo1">
          <h1 className="text-5xl md:text-6xl lg:text-8xl font-serif text-white leading-[1.1] mb-8 tracking-tight max-w-5xl mx-auto drop-shadow-2xl" data-id="element-196" data-mp="358rckfv9827q">
            The Future of Women's Wellness,{' '}
            <span className="italic text-white/95" data-id="element-197" data-mp="2viy2jjarfv5l">Curated Intelligently</span>
          </h1>
        </FadeIn>

        <FadeIn delay={500} data-id="element-198" data-mp="2hjf6vpz4yca6">
          <p className="text-lg md:text-2xl text-white/90 max-w-3xl mx-auto mb-12 font-light leading-relaxed drop-shadow-lg" data-id="element-199" data-mp="2hk8685vrlzia">
            A private digital ecosystem connecting women to trusted
            practitioners, personalized care, and intelligent wellness pathways
            — all in one seamless platform.
          </p>
        </FadeIn>

        <FadeIn delay={700} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-200" data-mp="n9i2r9bi38sj">
          <JoinPlatformButton className="w-full sm:w-auto bg-purple-200 text-gray-700 hover:bg-purple-300 shadow-xl font-sans font-black" data-id="element-201" data-mp="ddnf1zsf6niw" />
          <Button variant="outline" size="lg" className="w-full sm:w-auto border-2 border-white text-white hover:bg-white/20 backdrop-blur-sm bg-white/10 shadow-xl" data-id="element-202" data-mp="1b0dts484tzyq">
            Partner With Us
          </Button>
        </FadeIn>
      </div>
    </section>;
}